import type { UseMutationOptions, UseMutationResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { UpdateFundingDocumentMutationRequest, UpdateFundingDocumentMutationResponse, UpdateFundingDocumentQueryParams, UpdateFundingDocument400, UpdateFundingDocument401, UpdateFundingDocument403, UpdateFundingDocument404, UpdateFundingDocument410, UpdateFundingDocument422, UpdateFundingDocument429, UpdateFundingDocument500 } from "../types/UpdateFundingDocument";

/**
 * @link /api/credit-flow-backend/v1/document/do_upload-and-replace
 */

export function useUpdateFundingDocument <TData = UpdateFundingDocumentMutationResponse, TError = UpdateFundingDocument400 | UpdateFundingDocument401 | UpdateFundingDocument403 | UpdateFundingDocument404 | UpdateFundingDocument410 | UpdateFundingDocument422 | UpdateFundingDocument429 | UpdateFundingDocument500, TVariables = UpdateFundingDocumentMutationRequest>(params: UpdateFundingDocumentQueryParams, options: {
          mutation?: UseMutationOptions<ResponseConfig<TData>, TError, TVariables>,
          client?: Partial<Parameters<typeof client<TData, TError, TVariables>>[0]>,
      } = {}): UseMutationResult<ResponseConfig<TData>, TError, TVariables> {
  const { mutation: mutationOptions, client: clientOptions = {} } = options ?? {};

  return useMutation<ResponseConfig<TData>, TError, TVariables>({
    mutationFn: (data) => {
      
      return client<TData, TError, TVariables>({
        method: "post",
        url: `/api/credit-flow-backend/v1/document/do_upload-and-replace`,
        data,
        params,
        
        ...clientOptions
      });
    },
    ...mutationOptions
  });
};
